import colors from "../../base/colors";
import typography from "../../base/typography";

const { secondary } = colors;
const { size } = typography;

export default {
  styleOverrides: {
    root: {
      color: secondary.main,
      fontVariant: "all-small-caps",
    },
  },
};
